export interface SortChainEntry {
    map?: (value: any) => any;
    sort: (one: any, two: any) => number;
}

// FixMe: replace SortHelper with lodash
export abstract class SortHelper {
    public static sortNumber(one: number, two: number): number {
        return one - two;
    }

    public static sortCaseInsensitive(one: string, two: string): number {
        return one.toLocaleLowerCase().localeCompare(two.toLocaleLowerCase());
    }

    public static revertSortFunction(func: (one: any, two: any) => number): (one: any, two: any) => number {
        return (one: any, two: any): number => {
            return func(two, one);
        };
    }

    public static getSortFunctionForChain(chain: Array<SortChainEntry>): (one: any, two: any) => number {
        return (one: any, two: any): number => {
            for (const entry of chain) {
                let valueOne: any = one;
                let valueTwo: any = two;
                if (entry.map != null) {
                    valueOne = entry.map(one);
                    valueTwo = entry.map(two);
                }

                const result: number = entry.sort(valueOne, valueTwo);
                if (result !== 0) {
                    return result;
                }
            }
            return 0;
        };
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/utils/SortHelper.ts